import './ChatWindow.css';

function TypingIndicator() {
  return (
    <div className="typing-indicator" role="status">
      <span>Assistant is typing</span>
      <div className="typing-dots" aria-hidden="true">
        <div className="typing-dot"></div>
        <div className="typing-dot"></div>
        <div className="typing-dot"></div>
      </div>
    </div>
  );
}

export default TypingIndicator;
